import { render, staticRenderFns } from "./ExceptionEdit.vue?vue&type=template&id=4748e9a2&scoped=true&"
import script from "./ExceptionEdit.vue?vue&type=script&lang=js&"
export * from "./ExceptionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionEdit.vue?vue&type=style&index=0&id=4748e9a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4748e9a2",
  null
  
)

export default component.exports